import { e as isFunction, i as isArray, o as onDispose, x as noop } from './chunks/maverick-OwX0SrFa.js';
export { D as DOMEvent, I as EventTriggers, P as EventsTarget, O as appendTriggerEvent, H as attachDeclarativeShadowDOM, E as createComment, C as createFragment, a1 as createRegex, M as findTriggerEvent, K as getOriginEvent, G as getSlottedChildren, N as hasTriggerEvent, a0 as isBoolean, A as isDOMElement, J as isDOMEvent, B as isDOMFragment, z as isDOMNode, X as isKeyboardClick, U as isKeyboardEvent, T as isMouseEvent, Z as isNil, Y as isNull, $ as isNumber, _ as isObject, Q as isPointerEvent, b as isString, R as isTouchEvent, f as isUndefined, a2 as isWindow, y as listenEvent, q as setAttribute, v as setStyle, F as toggleClass, L as walkTriggerEventChain, V as wasEnterKeyPressed, W as wasEscapeKeyPressed } from './chunks/maverick-OwX0SrFa.js';
export { a as run, r as runAll } from './chunks/maverick-QudQjGGS.js';
export { c as camelToKebabCase, a as camelToTitleCase, b as kebabToCamelCase, k as kebabToPascalCase, d as kebabToTitleCase, l as lowercaseFirstLetter, t as trimTrailingSemicolon, u as uppercaseFirstChar } from './chunks/maverick-S-EudPoU.js';

function unwrap(fn) {
  return isFunction(fn) ? fn() : fn;
}
function unwrapDeep(fn) {
  let value = fn;
  while (typeof value === "function")
    value = value.call(this);
  return value;
}

function ariaBool(value) {
  return value ? "true" : "false";
}

function flattenArray(array) {
  const flat = [];
  for (let i = 0; i < array.length; i++) {
    if (isArray(array[i])) {
      flat.push(...flattenArray(array[i]));
    } else if (array[i] || array[i] === 0) {
      flat.push(array[i]);
    }
  }
  return flat;
}

function createDisposalBin() {
  const disposal = /* @__PURE__ */ new Set();
  return {
    add(...callbacks) {
      for (const callback of callbacks)
        disposal.add(callback);
    },
    empty() {
      for (const callback of disposal)
        callback();
      disposal.clear();
    }
  };
}
function useDisposalBin() {
  const disposal = createDisposalBin();
  onDispose(disposal.empty);
  return disposal;
}

function keysOf(obj) {
  return Object.keys(obj);
}
function mergeProperties(...sources) {
  const target = {};
  for (let i = 0; i < sources.length; i++) {
    const source = sources[i];
    if (source) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    }
  }
  return target;
}
function pick(source, props) {
  const target = {};
  for (const prop of props) {
    Object.defineProperty(target, prop, Object.getOwnPropertyDescriptor(source, prop));
  }
  return target;
}
function omit(source, props) {
  return pick(
    source,
    keysOf(source).filter((key) => !props.includes(key))
  );
}

function deferredPromise() {
  let resolve, reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return { promise, resolve, reject };
}
function timedPromise(promise, timeout, timeoutMsg) {
  const timer = new Promise((_, reject) => {
    const timerId = setTimeout(() => {
      clearTimeout(timerId);
      reject(timeoutMsg);
    }, timeout);
  });
  return Promise.race([promise, timer]);
}

function waitTimeout(delay) {
  return new Promise((resolve) => setTimeout(resolve, delay));
}
function waitAnimationFrame(callback) {
  return new Promise((resolve) => {
    window.requestAnimationFrame((time) => {
      callback?.(time);
      resolve();
    });
  });
}
function animationFrameThrottle(func) {
  let id = -1, lastArgs;
  function throttle(...args) {
    lastArgs = args;
    if (id >= 0)
      return;
    id = window.requestAnimationFrame(() => {
      func.apply(this, lastArgs);
      id = -1;
      lastArgs = void 0;
    });
  }
  return throttle;
}
const requestIdleCallback = typeof window !== "undefined" ? "requestIdleCallback" in window ? window.requestIdleCallback : (cb) => window.setTimeout(cb, 1) : noop;
function waitIdlePeriod(callback, options) {
  return new Promise((resolve) => {
    requestIdleCallback((deadline) => {
      callback?.(deadline);
      resolve();
    }, options);
  });
}

export { animationFrameThrottle, ariaBool, createDisposalBin, deferredPromise, flattenArray, isArray, isFunction, keysOf, mergeProperties, noop, omit, pick, timedPromise, unwrap, unwrapDeep, useDisposalBin, waitAnimationFrame, waitIdlePeriod, waitTimeout };
